export const reviews = () => {

    if (document.querySelector('.reviews__slider')) {


        // const stopSwiper = (swiper) => {
        //     if(swiper){
        //         let transformValue;
        //         let slidePercent;
        //         let durationPercent;
        //
        //         swiper.wrapperEl.addEventListener("mouseenter", function () {
        //             transformValue = window.getComputedStyle(swiper.wrapperEl).getPropertyValue("transform");
        //             const matrix = transformValue.match(/^matrix\((.+)\)$/);
        //             if (matrix && matrix[1]) {
        //                 const matrixValues = matrix[1].split(", ");
        //                 if (matrixValues.length >= 6) {
        //                     const translateX = parseFloat(matrixValues[4]);
        //                     swiper.autoplay.stop();
        //                     transformValue = this.style.transform;
        //                     this.style.transitionDuration = "0ms";
        //                     this.style.transform = "translate3d(" + translateX + "px, 0px, 0px)";
        //                 } else {
        //                     console.error("Matrix transformation does not contain the expected values:", transformValue);
        //                 }
        //             } else {
        //                 console.error("Unable to extract translateX value from transform property:", transformValue);
        //             }
        //
        //             const items = swiper.el.querySelectorAll(".swiper-slide");
        //             const dir = swiper.el.getAttribute("dir");
        //             if (dir && dir === "rtl") {
        //                 slidePercent =
        //                     ((window.innerWidth - items[swiper.activeIndex].getBoundingClientRect().right) * 100) / (items[swiper.activeIndex].offsetWidth + swiper.params.spaceBetween);
        //             } else {
        //                 slidePercent = (items[swiper.activeIndex].getBoundingClientRect().left * 100) / (items[swiper.activeIndex].offsetWidth + swiper.params.spaceBetween);
        //             }
        //             durationPercent = (swiper.params.speed * slidePercent) / 100;
        //         });
        //
        //         swiper.wrapperEl.addEventListener("mouseleave", function () {
        //             this.style.transitionDuration = `${durationPercent}ms`;
        //             this.style.transform = transformValue;
        //             swiper.autoplay.start();
        //         });
        //     }
        // }
        //
        // const sections = document.querySelectorAll('.reviews');
        // if(sections.length > 0){
        //     for(const section of sections){
        //         const slider = section.querySelector('.reviews__slider');
        //         if(slider){
        //             const sliderItems = slider.querySelectorAll('.reviews__slide');
        //             let slidesCount = sliderItems.length;
        //
        //             if(slidesCount > 0){
        //                 const swiper = new Swiper(slider, {
        //                     slidesPerView: 'auto',
        //                     loop: true,
        //                     spaceBetween: 25,
        //                     speed: sliderItems[0].offsetWidth * 10,
        //                     allowTouchMove: false,
        //                     simulateTouch: false,
        //                     keyboard: {
        //                         enabled: false,
        //                     },
        //                     autoplay: {
        //                         disableOnInteraction: false,
        //                         delay: 0,
        //                         pauseOnMouseEnter: false,
        //                     },
        //                 });
        //                 stopSwiper(swiper);
        //
        //             }
        //         }
        //     }
        // }



        const reviewsSwiper = new Swiper('.reviews__slider', {


            spaceBetween: 25,

            loop: true,

            slidesPerView:'auto',

            speed: 400,
            autoplay: {
                delay: 3500,
                // disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            navigation: {
                nextEl: '.reviews__next',
                prevEl: '.reviews__prev',
            },
        });


        // const reviewsSlider = document.querySelector('.reviews__slider')
        //
        // reviewsSlider.addEventListener('mouseover', () => {
        //     reviewsSwiper.autoplay.stop();
        // })
        //
        // reviewsSlider.addEventListener('mouseleave', () => {
        //     reviewsSwiper.autoplay.start();
        // })
    }

}
